import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { ContractTermsReadModel } from './types';

export const contractTermsApi = createApi({
  reducerPath: 'contractTermsApi',
  baseQuery: axiosBaseQuery({ baseUrl: Config.VITE_API_URL }),
  tagTypes: ['ContractTerms'],
  endpoints: builder => ({
    getContractTerms: builder.query<ContractTermsReadModel, string>({
      query: contractId => ({ url: `/contracts/${contractId}/terms` }),
      providesTags: (_, __, contractId) => [
        { type: 'ContractTerms', id: contractId },
      ],
    }),
  }),
});

export const { useGetContractTermsQuery } = contractTermsApi;
